import { formatValue, showLoader, printWorkAround, helpText } from '../data-viz-helpers.js'

customElements.define('zero-potential-value', class extends HTMLElement {
    static observedAttributes = ['data-value', 'data-pmpy', 'data-label', 'data-percentage', 'data-bg', 'data-fill', 'data-help', 'data-format', 'data-active-members']

    constructor() {
        super().attachShadow({mode: 'open'})
    }

    connectedCallback() {
        this.getProps()
        this.shadowRoot.innerHTML = showLoader([this.dataset.value], this.render())
    }

    attributeChangedCallback(_, oldVal, newVal) {
        if(oldVal !== newVal) {
            this.connectedCallback()
        }
    }

    getProps() {
        this.bg = this.dataset.bg ?? 'var(--color-4-lt)'
        this.fill = this.dataset.fill ?? 'var(--color-4-dk)'
        this.fill2 = this.dataset.fill2 ?? 'var(--color-4)'
        this.format = this.dataset.format ?? ''
        this.label = this.dataset.label ?? ''
        this.value = this.dataset.value ?? ''
        this.pmpy = this.dataset.pmpy ?? ''
        this.pmpyProg = (this.value / this.pmpy) * 100
        this.percentage = parseFloat(this.dataset.percentage)
        this.activeMembers = parseFloat(this.dataset.activeMembers) ?? ''
    }

    createChart(percentage, { value = '' }) {
        if (percentage < 0 || percentage > 100) {
            throw new Error('Percentage must be between 0 and 100')
        }

        return `
            <div class="wrap">
                <svg 
                    class="chart"
                    width="100" 
                    height="6"
                    viewBox="0 0 100 6"
                    preserveAspectRatio="none">

                    <rect class="bar" x="0" y="0" width="100" height="6"></rect>
                    <rect class="bar-fill" x="0" y="0" width="${percentage}" height="6"></rect>
                </svg>

                <p>${value}</p>
            </div>
        `
    }

    render() {
        return `
            <style>
                * {
                    box-sizing: border-box;
                }

                :host {
                    align-items: center;
                    background-color: ${this.bg};
                    border-radius: var(--chart-radius);
                    container-type: inline-size;
                    display: grid;
                    height: 100%;
                    overflow: clip;
                    padding: 2em;
                    padding-inline-start: 3em;
                    position: relative;
                    -webkit-user-select: none;
                    user-select: none;
                }

                .grid {
                    display: flex;
                    gap: 6cqi;
                }

                p {
                    margin: 0;
                }

                .current {
                    color: ${this.fill};
                    font-size: 10cqi;
                    font-weight: 900;
                }

                .label {
                    color: ${this.fill};
                    font-size: 3cqi;
                    font-weight: 700;
                    margin-block-end: 1ch;
                }

                .goal, .val, .pmpy {
                    color: ${this.fill};
                    font-size: 2.3cqi;
                }

                .goal {
                    font-weight: 500;
                }

                .percentage-wrap {
                    display: grid;
                    place-content: center;
                }

                .chart-wrap {
                    flex: 1;
                }

                .chart {
                    border-radius: 2cqi;
                    height: auto;
                    margin-block: 2cqi;
                    width: 100%;

                    .bar {
                        fill: ${this.fill2};
                        opacity: 0.2;
                    }

                    .bar-fill {
                        fill: ${this.fill2};
                    }
                }
            </style>

            ${printWorkAround(this)}

            <div class="grid">
                <div class="percentage-wrap">
                    <p class="current">${formatValue(this.percentage, 'percent')}</p>
                    <p class="label">${this.label}</p>
                    <p class="goal">1st Year Goal is 30%</p>
                </div>

                <div class="chart-wrap">
                    <p class="val">Current Value: <b>${formatValue(this.value / this.activeMembers, 'currency')} Utilization / Member</b></p>

                    <svg 
                        class="chart"
                        width="100" 
                        height="24"
                        viewBox="0 0 100 24"
                        preserveAspectRatio="none">

                        <rect class="bar" x="0" y="0" width="100" height="24"></rect>
                        <rect class="bar-fill" x="0" y="0" width="${this.pmpyProg}" height="24"></rect>
                    </svg>

                    <p class="pmpy">Total Potential Value: <b>${formatValue(this.pmpy / this.activeMembers, 'currency')}</b></p>
                </div>
            </div>
            
            ${helpText(this)}
        `
    }
})